import { Play, Pause } from "lucide-react";

interface PlayPauseButtonProps {
  isPlaying: boolean;
  onClick: () => void;
}

const PlayPauseButton = ({ isPlaying, onClick }: PlayPauseButtonProps) => {
  return (
    <button
      onClick={onClick}
      className="relative group"
      aria-label={isPlaying ? "Pause" : "Play"}
    >
      {isPlaying && (
        <>
          <span className="pulse-ring bg-primary/30" />
          <span className="pulse-ring bg-primary/20" style={{ animationDelay: "0.5s" }} />
          <span className="pulse-ring bg-primary/10" style={{ animationDelay: "1s" }} />
        </>
      )}

      <div className="relative w-16 h-16 sm:w-20 sm:h-20 rounded-full bg-gradient-to-br from-primary to-primary/80 glow-button flex items-center justify-center transition-transform duration-300 group-hover:scale-105 group-active:scale-95">
        {isPlaying ? (
          <Pause className="w-6 h-6 sm:w-8 sm:h-8 text-primary-foreground fill-current" />
        ) : (
          <Play className="w-6 h-6 sm:w-8 sm:h-8 text-primary-foreground fill-current ml-1" />
        )}
      </div>
    </button>
  );
};

export default PlayPauseButton;
